import React from "react";

const Home = () => {
  const tokens = localStorage.getItem("tokens");

  return (
    <div className="min-h-screen flex mt-5 justify-center items-center">
      <div className="w-full max-w-5xl space-y-6 sm:space-y-8">
        {/* Top header row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 pt-2">
          <h1 className="text-3xl sm:text-4xl  text-primary text-center md:text-left">
            Welcome to{" "}
            <span className=" tracking-wide">LISTERNAUT</span>{" "}
            Explorer
          </h1>

          <div className="flex justify-center md:justify-end">
            <div className="inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-primary/90 to-indigo-500 text-white px-4 py-2 shadow-md shadow-indigo-500/40">
              <span className="text-xs sm:text-sm opacity-80">Tokens Remaining</span>
              <span className="text-base sm:text-lg ">{tokens ?? "—"}</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-gradient-to-r from-primary via-indigo-400 to-primary/70 opacity-70" />


        {/* “To Start” instructions card */}
        <div className="rounded-3xl border border-slate-200/80 bg-gradient-to-br from-slate-50 via-slate-100 to-indigo-50/80 backdrop-blur-sm shadow-[0_18px_40px_rgba(15,23,42,0.14)] px-4 sm:px-6 py-5 sm:py-6">
          <h2 className="text-xl sm:text-2xl text-primary  mb-3">
            <span className="">To Start Checklist:</span>
          </h2>

          <ol className="mt-3 space-y-2 text-base sm:text-lg text-primary max-w-3xl list-decimal list-inside">
            <li>
              In the left menu, click <span className="">Catalog with UPC/AI</span>.
            </li>
            <li>
              Click <span className="">Create Catalog</span> and give it a name.
            </li>
            <li>
              Choose <span className="">Individual</span> or{" "}
              <span className="">Bulk</span>:
              <span className="block pl-6 mt-1 text-primary/90">
                <span className="">Individual</span> is best for UPC/AI scans (one lot at a time).
                <br />
                <span className="">Bulk</span> is best if you already have a folder of images or a spreadsheet.
              </span>
            </li>
            <li>
              For step-by-step walkthroughs, watch our tutorials{" "}
              <button
                className=" text-indigo-600 hover:text-indigo-700 underline decoration-indigo-400 decoration-2 underline-offset-4"
                onClick={() => window.open("https://listernaut.com/pages/e-commerce-tutorials", "_blank")}
              >
                here
              </button>
              . If you need help, schedule a quick call{" "}
              <button
                className=" text-indigo-600 hover:text-indigo-700 underline decoration-indigo-400 decoration-2 underline-offset-4"
                onClick={() => window.open("https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard", "_blank")}
              >
                click here
              </button>
              .
            </li>
            <li>
              For full documentation, click{" "}
              <button
                className=" text-indigo-600 hover:text-indigo-700 underline decoration-indigo-400 decoration-2 underline-offset-4"
                onClick={() => window.open("https://explorer.listernaut.com/documentation", "_blank")}
              >
                here
              </button>
              .
            </li>
          </ol>

        
        </div>

        {/* Thank you card */}
        <div className="rounded-3xl border border-slate-200/80 bg-white/80 backdrop-blur-sm shadow-[0_16px_32px_rgba(15,23,42,0.12)] px-4 sm:px-6 py-4 sm:py-5">
          <h2 className="text-xl sm:text-2xl text-primary ">
            Thank you for choosing Listernaut Explorer — we appreciate you. 🚀
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Home;
